import { render, staticRenderFns } from "./PricingDiscount.template.vue?vue&type=template&id=c6676b10&scoped=true&"
var script = {}
import style0 from "./PricingDiscount.template.vue?vue&type=style&index=0&id=c6676b10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6676b10",
  null
  
)

export default component.exports